import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable, map, of } from 'rxjs';

import { Organisation, SilverfinFirm } from '@/organisations/models';

import { environment } from '@env';

export type PeriodLookUp = {
    periodId: number;
    endDate: Date;
    fiscalYearStart: Date;
    fiscalYearEnd: Date;
};

@Injectable({
    providedIn: 'root',
})
export class SilverfinApiService {
    constructor(private http: HttpClient) {}

    /**
     * Retrieve the firm of the user logged in via silverfin
     * @return {Observable<SilverfinFirm>} - The silverfin firm if the user logged in via silverfin, otherwise an error
     */
    getUserFirm(): Observable<SilverfinFirm> {
        return this.http.get<SilverfinFirm>(environment.endpoints.silverfinApiFirm);
    }

    getLinkedFirmOrganisations(firmId: number): Observable<number[]> {
        return this.http.get<number[]>(environment.endpoints.silverfinApiFirmLookup, { params: { 'firm_id': firmId } });
    }

    companyPeriodLookup(organisationId: number, companyId: number, periodId: number): Observable<PeriodLookUp> {
        return this.http
            .post<any>(environment.endpoints.organisationCompanyPeriodLookup(organisationId, companyId), {
                'period_id': periodId,
            })
            .pipe(
                map((response) => {
                    return {
                        periodId: response.period_id,
                        endDate: new Date(response.end_date),
                        fiscalYearStart: new Date(response.fiscal_year_start),
                        fiscalYearEnd: new Date(response.fiscal_year_end),
                    } as PeriodLookUp;
                }),
            );
    }
}
